import { useState } from 'react';
import LZString from 'lz-string';

const useSessionStorage = (key, initialValue = []) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(LZString.decompress(item)) : initialValue;
    } catch (error) {
      console.error('Error reading sessionStorage:', error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const compressedValue = LZString.compress(JSON.stringify(value));
      sessionStorage.setItem(key, compressedValue);
      setStoredValue(value);
    } catch (error) {
      console.error('Error setting sessionStorage:', error);
    }
  };

  return [storedValue, setValue]; //, setValue
};

export default useSessionStorage;
